import sliceCreator from '../../index.jsx';
import {CREATE_POST_MONTHLY_TARGET} from '../../../constants/index.jsx';
const _createPostMonthlyTargetAction = sliceCreator('CREATE_POST_MONTHLY_TARGET', CREATE_POST_MONTHLY_TARGET, 'post');

const { asyncAction: createPostMonthlyTargetAction, reducer, clearData: clearCreatePostMonthlyTargetAction } = _createPostMonthlyTargetAction;

export default reducer;

export {
    createPostMonthlyTargetAction,
    clearCreatePostMonthlyTargetAction
}